<template>

  <div class="col-12">
    <div class="row header">
      <div class="col-8">
        <h2>{{ name }}</h2>
      </div>
      <div class="col-4 col-actions">

        <template v-if="isWsOwnerOrAdmin() && page === 'PROJECT'">
            <ButtonElement class="btn--ms btn--silent-tertiary btn--regular" @clickOnButton="routeToTrash">
              <span class="icon"><LucideIcon icon="Trash2"/></span>
              Trash <span
                v-if="trashedProjectCount > 0">({{ trashedProjectCount }})</span>
            </ButtonElement>
        </template>


        <div class="list-view-action">
          <ButtonElement class="btn-grid-view"
                         :class="{'btn--ms btn--accent': dashboardViewMode==='GRID',
                         'btn--ms btn--silent-secondary': dashboardViewMode==='LIST'}"
                         data-tooltip="Grid View"
                         data-tooltip-position="bottom"
                         @clickOnButton="setViewMode('GRID')">
            <LucideIcon icon="Grid2x2"/>
          </ButtonElement>
          <ButtonElement class="btn-list-view"
                         :class="{'btn--ms btn--accent': dashboardViewMode==='LIST',
                         'btn--ms btn--silent-secondary': dashboardViewMode==='GRID'}"
                         data-tooltip="List View"
                         data-tooltip-position="bottom"
                         @clickOnButton="setViewMode('LIST')">
            <LucideIcon icon="Menu"/>
          </ButtonElement>
        </div>

        <template v-if="isWsOwnerOrAdmin() && page === 'PROJECT'">
            <ButtonElement class="btn--ms btn--accent"
                           @clickOnButton="$emit('onCreateContainer')">
              <LucideIcon icon="Plus"/>
              Container
            </ButtonElement>
        </template>

        <template v-if="isWsOwnerOrAdmin() && page === 'TRASH'">
          <ButtonElement class="btn--ms btn--neutral"
                         @clickOnButton="routeToDashboard">
            <span class="icon"><LucideIcon icon="ArrowLeft"/></span>
            Back to  Dashboard
          </ButtonElement>
        </template>


      </div>
    </div>
  </div>

</template>


<script lang="ts">
import {defineComponent} from 'vue';
import {ButtonElement} from '@shared/components/elements';
import {DashboardNs} from '@shared/types';
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useUserStore} from "@shared/stores/user.store";
import {mapStores} from "pinia";
import {isWsOwnerOrAdmin} from "@shared/mixins/role-manager";
import {useProjectStore} from "@domains/dashboard/stores/project.store";


export default defineComponent({
  name: 'PageHeaderWidget',
  components: {
    ButtonElement
  },
  emits: ['onCreateContainer'],
  props: {
    name: {
      type: String,
      required: true
    },
    page: {
      type: String,
      required: true
    }
  },
  setup() {
    // initialize the store
    const workspaceStore = useWorkspaceStore()
    const projectStore = useProjectStore()
    return {workspaceStore, projectStore}
  },
  computed: {
    ...mapStores(useUserStore, useWorkspaceStore),
    dashboardViewMode(): 'GRID' | 'LIST' {
      return this.userStore.getDashboardViewMode;
    },
    trashedProjectCount(): number {
      return this.projectStore.getTrashedProjectCount;
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    this.projectStore.loadTrashedProjectCount({workspaceId: this.workspaceStore.getSelectedWorkspaceId})
    .then(() => {})
  },
  methods: {
    isWsOwnerOrAdmin,
    setViewMode(viewMode: string) {
      this.userStore.setDashboardPreferences({
        preferences: 'viewMode',
        value: viewMode
      }).then(() => {
      });
    },

    routeToTrash(): void {
      this.$router.push({name: DashboardNs.DashboardRouteEnums.TRASH})
    },
    routeToDashboard(): void {
      this.$router.push({name: DashboardNs.DashboardRouteEnums.PROJECTS});
    }
  }
});

</script>
<style lang="scss" scoped>

.page-container {
  width: 100%;
  padding-right: var(--bs-gutter-x, 12px);
  padding-left: var(--bs-gutter-x, 12px);
  margin-right: auto;
  margin-left: auto;

  & .header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    margin-top: var(--space-16);;
    margin-bottom: var(--space-16);;

    .action {
      display: flex;
      justify-content: flex-end;
    }

    h1, h2 {
      font-weight: bold;
      margin: var(--space-0);
    }
  }
}

.btn-header:last-child {
  margin-right: var(--space-0) !important;
}

.col-actions{
  display: flex;
  justify-content: flex-end;
  gap: var(--space-8);
}

.list-view-action {
  display: flex;

  .btn-grid-view {
    margin: var(--space-0);
    border-top-right-radius: var(--space-0);
    border-bottom-right-radius:var(--space-0);
  }

  .btn-list-view {
    margin:var(--space-0);
    border-top-left-radius: var(--space-0);
    border-bottom-left-radius: var(--space-0);
  }
}
</style>
